import { useMemo } from "react";
import InlineError from "../components/inline-error.js";
import { FillContainerLoader } from "../components/loader.js";
import trpc from "../utils/trpc.js";
import { IsolatedHtml } from "../components/isolated-html.js";
import { sanitizeCanvasHtml, getCanvasCssLinks } from "../utils/canvas.js";
import { useParams } from "react-router-dom";
import { useCanvasBrandVariables } from "../hooks/use-canvas-brand-variables.js";
import { useH5PResizer } from "../hooks/use-h5p-resizer.js";
import { useChat } from "../providers/chat.js";

function Page() {
  const { pageId } = useParams();
  const { openChat } = useChat();

  // This hook sets up the H5P iframe resizer, which listens for messages from H5P content and resizes the iframe accordingly.
  useH5PResizer();

  const {
    data: page,
    isLoading: isPageLoading,
    error,
  } = trpc.course.getPage.useQuery({ pageId: pageId }, { staleTime: Infinity });

  const { mutateAsync: getMagicLink } = trpc.aier.getMagicLink.useMutation();
  const { mutateAsync: getAutoLink } = trpc.lqm.getAutoLink.useMutation();

  const { inlineCss: brandVarsInlineCss, isLoading: isBrandVarsLoading } = useCanvasBrandVariables();

  const sanitized = useMemo(() => sanitizeCanvasHtml(page?.body ?? null), [page?.body]);
  const cssLinks = useMemo(() => getCanvasCssLinks(), []);

  if (isPageLoading || isBrandVarsLoading) return <FillContainerLoader delayMs={0} />;
  if (error) return <InlineError message="We couldn't load this page. Please try refreshing." />;
  if (!page) return <div className="text-sm">No page available.</div>;

  return (
    <>
      {sanitized && (
        <IsolatedHtml
          html={sanitized}
          cssLinks={cssLinks}
          inlineCss={brandVarsInlineCss}
          onMagicLinkClick={async url => {
            const result = await getMagicLink({ webUrl: url });
            window.open(result.url, "_blank", "noopener");
          }}
          onLqmLinkClick={async () => {
            const result = await getAutoLink();
            window.open(result.url, "_blank", "noopener");
          }}
          onOpenChatClick={openChat}
        />
      )}
    </>
  );
}

export { Page as Component };
